import React, { useState, useEffect, useContext } from 'react';
import SwipeableViews from 'react-swipeable-views';
import axios from 'axios';
import AppContext from '../../Context/AppContext';
import StepHeader from '../Step1/StepHeader';
import Header from './Header/Header';
import SelectGoalSection from './SelectGoals/SelectGoalSection';
import configData from '../../config.json';
import OolaSevenSection from './SelectGoals/OolaSevenSection';
import OolaOneSection from './SelectGoals/OolaOneSection';
import OolaFinishSection from './SelectGoals/OolaFinishSection';
import OolaOneSectionSelect from './SelectGoals/OolaOneSectionSelect';
import './SelectGoalsStep2.css';
import SelectFinishSection from './SelectGoals/SelectFinishSection';

const SelectGoalsStep2 = (props) => {
    const { checkUserSession, updateUserStepId, changeLoading } =
        useContext(AppContext);
    const currUser = checkUserSession();
    const [show, setShow] = useState(false);

    const [saving, savingChange] = useState(0);

    const [data, changeData] = useState({
        CurrentF: 0,
        CurrentStep2: 0,
        LastReachedF: 0,
        latestAssessmentScore: 0,
        Fs: [
            {
                areaId: 1,
                name: 'Fitness',
                score: 0,
                color: '#15C285',
                recommendedGoals: [],
            },
            {
                areaId: 2,
                name: 'Finance',
                score: 0,
                color: '#ABD86D',
                recommendedGoals: [],
            },
            {
                areaId: 3,
                name: 'Family',
                score: 0,
                color: '#FBBF53',
                recommendedGoals: [],
            },
            {
                areaId: 4,
                name: 'Faith',
                score: 0,
                color: '#F26636',
                recommendedGoals: [],
            },
            {
                areaId: 5,
                name: 'Field',
                score: 0,
                color: '#EC0F47',
                recommendedGoals: [],
            },
            {
                areaId: 6,
                name: 'Friends',
                score: 0,
                color: '#700460',
                recommendedGoals: [],
            },
            {
                areaId: 7,
                name: 'Fun',
                score: 0,
                color: '#022B7A',
                recommendedGoals: [],
            },
        ],
        SelectedGoals: [],
        SelectedGoalsSeven: [],
        SelectedOolaOne: {},
    });

    const dataLoad = () =>
        data.Fs.map((item) => ({
            id: item.areaId,
            name: item.name,
            tabColor: item.color,
        }));

    function updateIndexStep2(i) {
        // Functional update — avoid stale state wiping SelectedGoalsSeven, etc.
        changeData((prev) => ({
            ...prev,
            CurrentStep2: (Number(prev.CurrentStep2) || 0) + i,
            changeData,
        }));
        window.scrollTo(0, 0);
    }

    function getURL() {
        return configData.SERVER_URL;
    }

    useEffect(() => {
        const applyStep2Preview = (newAllProps, Fs) => {
            try {
                const preview = new URLSearchParams(
                    window.location.search
                ).get('preview');
                if (
                    preview === 'step2' ||
                    preview === 'step2-goals' ||
                    preview === 'goals'
                ) {
                    newAllProps.CurrentStep2 = 1;
                    newAllProps.CurrentF = Math.min(
                        Number(newAllProps.CurrentF) || 0,
                        6
                    );
                    newAllProps.LastReachedF = Math.max(
                        Number(newAllProps.LastReachedF) || 0,
                        newAllProps.CurrentF
                    );
                }
                if (
                    preview === 'step2-pick7' ||
                    preview === 'pick7' ||
                    preview === 'top7'
                ) {
                    newAllProps.CurrentStep2 = 3;
                    newAllProps.CurrentF = 0;
                    newAllProps.LastReachedF = 6;
                    if (
                        !newAllProps.SelectedGoals ||
                        newAllProps.SelectedGoals.length < 3
                    ) {
                        const seeded = [];
                        (Fs || []).forEach((f, areaId) => {
                            for (let i = 0; i < 3; i += 1) {
                                const d = new Date();
                                d.setDate(d.getDate() + 30 + i * 7);
                                seeded.push({
                                    areaId,
                                    recomendationIndex: i,
                                    text: `${f.name} goal ${
                                        i + 1
                                    } — live with more intention`,
                                    date: d,
                                    Id: seeded.length,
                                    selected: false,
                                });
                            }
                        });
                        newAllProps.SelectedGoals = seeded;
                        newAllProps.SelectedGoalsSeven = [];
                        delete newAllProps.SelectedGoalsGroup;
                    }
                }
                if (
                    preview === 'step2-arrange' ||
                    preview === 'arrange' ||
                    preview === 'arrange7' ||
                    preview === 'step2-oolaone' ||
                    preview === 'oolaone' ||
                    preview === 'oola1' ||
                    preview === 'step2-finish' ||
                    preview === 'step2-complete' ||
                    preview === 'finish'
                ) {
                    const isOolaOnePreview =
                        preview === 'step2-oolaone' ||
                        preview === 'oolaone' ||
                        preview === 'oola1';
                    const isFinishPreview =
                        preview === 'step2-finish' ||
                        preview === 'step2-complete' ||
                        preview === 'finish';
                    newAllProps.CurrentStep2 = isFinishPreview
                        ? 7
                        : isOolaOnePreview
                          ? 6
                          : 4;
                    newAllProps.CurrentF = 0;
                    newAllProps.LastReachedF = 6;

                    let top7 = (newAllProps.SelectedGoalsSeven || []).filter(
                        Boolean
                    );

                    if (top7.length < 7) {
                        try {
                            const raw =
                                sessionStorage.getItem('pv2-top7-picks');
                            const stored = raw ? JSON.parse(raw) : null;
                            if (Array.isArray(stored) && stored.length > 0) {
                                top7 = stored.filter(Boolean);
                            }
                        } catch {
                            /* ignore */
                        }
                    }

                    if (top7.length > 0) {
                        newAllProps.SelectedGoalsSeven = top7.slice(0, 7);
                    } else {
                        const areas =
                            (Fs || []).length > 0
                                ? Fs
                                : [
                                      { name: 'Fitness', color: '#15c285' },
                                      { name: 'Finance', color: '#efd078' },
                                      { name: 'Family', color: '#5b8def' },
                                      { name: 'Friends', color: '#e07a5f' },
                                      { name: 'Field', color: '#81b29a' },
                                      { name: 'Faith', color: '#9b5de5' },
                                      { name: 'Fun', color: '#f28482' },
                                  ];
                        if (!(Fs || []).length) {
                            newAllProps.Fs = areas;
                        }
                        newAllProps.SelectedGoalsSeven = areas.map(
                            (f, areaId) => {
                                const d = new Date();
                                d.setDate(d.getDate() + 40 + areaId);
                                return {
                                    areaId,
                                    recomendationIndex: 0,
                                    text: `${f.name}: lead with purpose this season`,
                                    date: d,
                                    Id: areaId,
                                    GoalId: null,
                                    selected: true,
                                    selectedOne: false,
                                    idL: `${areaId}0`,
                                };
                            }
                        );
                    }

                    if (isOolaOnePreview) {
                        newAllProps.SelectedGoalsSeven = (
                            newAllProps.SelectedGoalsSeven || []
                        ).map((g) => ({
                            ...g,
                            selectedOne: false,
                        }));
                        newAllProps.SelectedOolaOne = {};
                    }

                    if (isFinishPreview) {
                        const seven = newAllProps.SelectedGoalsSeven || [];
                        const pick =
                            seven.find((g) => g?.selectedOne) ||
                            (newAllProps.SelectedOolaOne?.text
                                ? newAllProps.SelectedOolaOne
                                : null) ||
                            seven.find((g) => Number(g.areaId) === 2) ||
                            seven[0] || {
                                areaId: 2,
                                text: 'Schedule an appointment with a family counselor',
                            };
                        newAllProps.SelectedOolaOne = {
                            ...pick,
                            selectedOne: true,
                        };
                        newAllProps.SelectedGoalsSeven = seven.map((g, i) => ({
                            ...g,
                            selectedOne:
                                (pick.GoalId != null &&
                                    g.GoalId === pick.GoalId) ||
                                (pick.idL && g.idL === pick.idL) ||
                                (g.areaId === pick.areaId &&
                                    g.text === pick.text) ||
                                i === seven.indexOf(pick),
                        }));
                    }
                }
            } catch {
                /* ignore */
            }
            return newAllProps;
        };

        const url = `${getURL()}goals/${currUser.userId}`;
        axios
            .get(url, {
                headers: { Authorization: `Bearer ${currUser.token}` },
            })
            .then((result) => {
                const AllProps = { ...data };
                const Fs = [];
                (result.data || []).forEach((item) => {
                    Fs.push(item);
                });
                AllProps.Fs = Fs;
                AllProps.changeData = changeData;
                changeData(AllProps);

                const urlGoals = `${getURL()}goals/GetUserGoals`;
                axios
                    .get(urlGoals, {
                        headers: { Authorization: `Bearer ${currUser.token}` },
                    })
                    .then((result2) => {
                        const newAllProps = {
                            ...data,
                            SelectedGoals: [],
                            SelectedGoalsSeven: [],
                        };
                        let index = 0;
                        (result2.data?.userGoals || []).forEach((item) => {
                            if (index === 3) index = 0;
                            let dateValue = null;
                            if (
                                item.completedByDate &&
                                item.completedByDate !== ''
                            ) {
                                const parsedDate = new Date(
                                    item.completedByDate
                                );
                                dateValue = !isNaN(parsedDate.getTime())
                                    ? parsedDate
                                    : null;
                            }
                            newAllProps.SelectedGoals.push({
                                recomendationIndex: index,
                                text: item.text,
                                areaId: item.areaId - 1,
                                date: dateValue,
                                GoalId: item.goalId,
                            });
                            index += 1;
                        });
                        newAllProps.Fs = Fs;
                        newAllProps.latestAssessmentScore =
                            result2.data?.latestAssessmentScore;
                        newAllProps.changeData = changeData;
                        newAllProps.CurrentF = Math.floor(
                            newAllProps.SelectedGoals.length / 3
                        );
                        newAllProps.LastReachedF = newAllProps.CurrentF;

                        if (newAllProps.CurrentF > 0) {
                            if (newAllProps.SelectedGoals.length === 21) {
                                const unordered = (
                                    result2.data.userGoals || []
                                ).filter((x) => x.sevenGoalOrder === 0);
                                const ordered = (
                                    result2.data.userGoals || []
                                ).filter((x) => x.sevenGoalOrder > 0);

                                if (unordered.length === 7) {
                                    unordered.forEach((item, i) => {
                                        const x =
                                            newAllProps.SelectedGoals.find(
                                                (xx) =>
                                                    xx.GoalId === item.goalId
                                            );
                                        if (!x) return;
                                        newAllProps.SelectedGoalsSeven.push({
                                            areaId: x.areaId,
                                            date: x.date,
                                            recomendationIndex:
                                                x.recomendationIndex,
                                            text: x.text,
                                            selected: true,
                                            Id: i,
                                            GoalId: x.GoalId,
                                        });
                                    });
                                    newAllProps.CurrentStep2 = 4;
                                } else if (ordered.length === 7) {
                                    ordered
                                        .sort(
                                            (a, b) =>
                                                a.sevenGoalOrder -
                                                b.sevenGoalOrder
                                        )
                                        .forEach((item, i) => {
                                            const x =
                                                newAllProps.SelectedGoals.find(
                                                    (xx) =>
                                                        xx.GoalId ===
                                                        item.goalId
                                                );
                                            if (!x) return;
                                            newAllProps.SelectedGoalsSeven.push(
                                                {
                                                    areaId: x.areaId,
                                                    date: x.date,
                                                    recomendationIndex:
                                                        x.recomendationIndex,
                                                    text: x.text,
                                                    selected: true,
                                                    Id: i,
                                                    GoalId: x.GoalId,
                                                }
                                            );
                                        });
                                    newAllProps.CurrentStep2 = 5;
                                } else {
                                    newAllProps.CurrentStep2 = 2;
                                }

                                newAllProps.CurrentF = 0;
                            } else {
                                newAllProps.CurrentStep2 = 1;
                            }
                        }

                        changeData(applyStep2Preview(newAllProps, Fs));
                        changeLoading(false);
                    })
                    .catch((error) => {
                        console.log(error);
                        const fallback = {
                            ...data,
                            Fs,
                            changeData,
                            SelectedGoals: [],
                            SelectedGoalsSeven: [],
                        };
                        changeData(applyStep2Preview(fallback, Fs));
                        changeLoading(false);
                    });
            })
            .catch((error) => {
                console.log(error);
                const fallback = {
                    ...data,
                    changeData,
                    SelectedGoals: [],
                    SelectedGoalsSeven: [],
                };
                changeData(applyStep2Preview(fallback, []));
                changeLoading(false);
            });
    }, []);

    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    function changePage() {
        updateIndexStep2(1);
    }
    function saveRecomendedGoals(options = {}) {
        const opts =
            options && typeof options === 'object' ? options : {};
        const areaId =
            opts.areaId != null ? opts.areaId : data.CurrentF;
        // V2: no full-page loader so F switches stay instant
        const silent =
            opts.silent === true ||
            (opts.silent !== false && Boolean(props.portalV2));

        if (!silent) {
            savingChange(1);
            changeLoading(true);
        } else {
            savingChange(1);
        }

        const PostObj = {
            userId: currUser.userId,
            Goals: data.SelectedGoals.filter(
                (x) => x.areaId === areaId
            ).map((item) => ({
                GoalId: item.GoalId,
                AreaId: item.areaId + 1,
                Text: item.text,
                CompletedByDate: item.date,
            })),
        };

        const url = `${configData.SERVER_URL}Goals/PartialSaveGoals`;
        return new Promise((resolve) => {
            axios
                .post(url, PostObj, {
                    headers: {
                        Authorization: `Bearer ${currUser.token}`,
                    },
                })
                .then((result) => {
                    savingChange(0);
                    if (!silent) changeLoading(false);
                    // Merge GoalIds without resetting CurrentF / navigation
                    changeData((prev) => {
                        const SelectedGoals = prev.SelectedGoals.map(
                            (g) => ({ ...g })
                        );
                        SelectedGoals.filter(
                            (x) => x.areaId === areaId
                        ).forEach((item, i) => {
                            if (
                                item.GoalId == null &&
                                result.data &&
                                result.data[i]
                            ) {
                                item.GoalId = result.data[i].id;
                            }
                        });
                        return {
                            ...prev,
                            SelectedGoals,
                            changeData,
                        };
                    });
                    resolve(true);
                })
                .catch((error) => {
                    savingChange(0);
                    console.log(error);
                    if (!silent) changeLoading(false);
                    resolve(false);
                });
        });
    }
    const obj = (
        <>
            {data.CurrentStep2 === 1 &&
                data.LastReachedF > data.CurrentF &&
                props.mobile === false &&
                !props.portalV2 && (
                    <button
                        className="btnPartialSaveStep2 "
                        type="button"
                        onClick={() => saveRecomendedGoals()}
                    >
                        SAVE
                    </button>
                )}
            <SwipeableViews
                className="step2__container"
                index={data.CurrentStep2}
                disabled
            >
                <section
                    className="step1__container pv2-step2-video"
                    style={
                        props.portalV2
                            ? { height: 'auto' }
                            : { height: '100%' }
                    }
                >
                    {data.CurrentStep2 === 0 ? (
                        <div className="stepHeader__container">
                            <StepHeader
                                key="step2-video-intro"
                                url="https://player.vimeo.com/video/539418550"
                                title="STEP 2: WHERE YOU WANT TO GO"
                                description={
                                    'We are on this planet to help you FIND BALANCE \n and a live of less stress and greater propuse - the OOLALIFE'
                                }
                                changePage={changePage}
                                mobile={props.mobile}
                                portalV2={!!props.portalV2}
                            />
                        </div>
                    ) : null}
                </section>
                <div className="section" style={{ height: 'auto' }}>
                    {data.CurrentStep2 === 1 ? (
                        <div
                            className={
                                props.portalV2
                                    ? 'pv2-step2-glass'
                                    : undefined
                            }
                        >
                            {!props.portalV2 ? (
                                <Header
                                    data={dataLoad()}
                                    AllState={data}
                                    changeData={changeData}
                                    mobile={props.mobile}
                                    saveRecomendedGoals={saveRecomendedGoals}
                                />
                            ) : null}
                            {props.portalV2 ? (
                                <SelectGoalSection
                                    mobile={props.mobile}
                                    FData={dataLoad()[data.CurrentF]}
                                    AllState={data}
                                    saveRecomendedGoals={saveRecomendedGoals}
                                    portalV2
                                />
                            ) : (
                                <SwipeableViews
                                    AllState={data}
                                    index={data.CurrentF}
                                    disabled
                                    style={{
                                        '--marginCalendar': `${
                                            window.innerWidth * data.CurrentF
                                        }px`,
                                    }}
                                    className="step2EstablishGoal__container"
                                >
                                    {dataLoad().map((item) => (
                                        <SelectGoalSection
                                            key={item.id}
                                            mobile={props.mobile}
                                            FData={item}
                                            AllState={data}
                                            saveRecomendedGoals={
                                                saveRecomendedGoals
                                            }
                                        />
                                    ))}
                                </SwipeableViews>
                            )}
                            {!props.portalV2 &&
                                data.LastReachedF > data.CurrentF &&
                                props.mobile === true && (
                                    <button
                                        className="btnPartialSaveStep2Mobile "
                                        type="button"
                                        onClick={() => saveRecomendedGoals()}
                                    >
                                        SAVE
                                    </button>
                                )}
                        </div>
                    ) : null}
                </div>
                <section
                    className="step1__container pv2-step2-video"
                    style={
                        props.portalV2
                            ? { height: 'auto' }
                            : { height: '100%' }
                    }
                >
                    {data.CurrentStep2 === 2 ? (
                        <div className="stepHeader__container">
                            <StepHeader
                                key="step2-video-top7"
                                url="https://player.vimeo.com/video/539436782"
                                title="STEP 2: TOP 7 GOALS"
                                description={
                                    'We are on this planet to help you FIND BALANCE \n and a live of less stress and greater propuse - the OOLALIFE'
                                }
                                height="100%"
                                changePage={changePage}
                                mobile={props.mobile}
                                portalV2={!!props.portalV2}
                            />
                        </div>
                    ) : null}
                </section>
                <div className="section">
                    {data.CurrentStep2 !== 3 ? (
                        ''
                    ) : (
                        <div>
                            <OolaSevenSection
                                handleChangeHeader={props.handleChangeHeader}
                                forceUpdate={forceUpdate}
                                updateIndexStep2={updateIndexStep2}
                                AllState={data}
                                changeData={changeData}
                                portalV2={props.portalV2}
                            />
                        </div>
                    )}
                </div>

                <div className="section">
                    {data.CurrentStep2 !== 4 ? (
                        ''
                    ) : (
                        <div
                            style={
                                props.portalV2
                                    ? undefined
                                    : { overflowY: 'scroll' }
                            }
                        >
                            <OolaOneSection
                                handleChangeHeader={props.handleChangeHeader}
                                AllState={data}
                                changeData={changeData}
                                forceUpdate={forceUpdate}
                                updateIndexStep2={updateIndexStep2}
                                portalV2={props.portalV2}
                            />
                        </div>
                    )}
                </div>
                <section
                    className="step1__container pv2-step2-video"
                    style={
                        props.portalV2
                            ? { height: 'auto' }
                            : { height: '100%' }
                    }
                >
                    {data.CurrentStep2 === 5 ? (
                        <div className="stepHeader__container">
                            <StepHeader
                                key="step2-video-oolaone"
                                url="https://player.vimeo.com/video/539438606"
                                title="STEP 2: MY OOLA ONE"
                                description={
                                    'We are on this planet to help you FIND BALANCE \n and a live of less stress and greater propuse - the OOLALIFE'
                                }
                                height="100%"
                                changePage={changePage}
                                mobile={props.mobile}
                                portalV2={!!props.portalV2}
                            />
                        </div>
                    ) : null}
                </section>
                <div className="section">
                    {data.CurrentStep2 !== 6 ? (
                        ''
                    ) : (
                        <div
                            style={
                                props.portalV2
                                    ? undefined
                                    : { minHeight: '130vh' }
                            }
                        >
                            <OolaOneSectionSelect
                                handleChangeHeader={props.handleChangeHeader}
                                AllState={data}
                                changeData={changeData}
                                forceUpdate={forceUpdate}
                                updateIndexStep2={updateIndexStep2}
                                portalV2={props.portalV2}
                            />
                        </div>
                    )}
                </div>
            <div
                className="section"
                style={{
                    width: '100%',
                    overflowX: 'hidden',
                    overflowY: 'hidden',
                }}
            >
                {data.CurrentStep2 === 7 ? (
                <SelectFinishSection
                    isFinishAction={1}
                    AllState={data}
                    handleChangeHeader={props.handleChangeHeader}
                    mobile={props.mobile}
                    changeData={changeData}
                    forceUpdate={forceUpdate}
                    updateIndexStep2={updateIndexStep2}
                    handleChangeindexStep={props.handleChangeindexStep}
                    hideNav={false}
                    portalV2={props.portalV2}
                />
                ) : (
                    ''
                )}
            </div>
            </SwipeableViews>
        </>
    );
    return obj;
};

export default SelectGoalsStep2;
